import { SegmentView } from "@tiny/api";
import { SegmentCard } from "./PredefinedSegments.types";

function isRecommendedSegment(
  segmentView: SegmentView
): segmentView is SegmentCard {
  return segmentView.segmentType === "PREDEFINED_RECOMMENDED";
}

function isLibrarySegment(
  segmentView: SegmentView
): segmentView is SegmentCard {
  return segmentView.segmentType === "PREDEFINED_LIBRARY";
}

function isDeliverySegment(
  segmentView: SegmentView
): segmentView is SegmentCard {
  return segmentView.segmentType === "PREDEFINED_DELIVERY";
}

function segmentView2Card(
  segmentView: SegmentView & {
    segmentType:
      | "PREDEFINED_RECOMMENDED"
      | "PREDEFINED_LIBRARY"
      | "PREDEFINED_DELIVERY";
  }
) {
  return {
    id: segmentView.id!,
    name: segmentView.name!,
    description: segmentView.description!,
    segmentType: segmentView.segmentType!,
  };
}

export {
  isRecommendedSegment,
  isLibrarySegment,
  segmentView2Card,
  isDeliverySegment,
};
